/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Partial update of a practice from the practices tab; the logo and stamp have their own endpoints.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatchedPracticeUpdate { 
    name?: string;
    organizations?: Array<number>;
    street?: string;
    houseNumber?: string;
    postalCode?: string;
    city?: string;
    owner?: number | null;
    email?: string;
    phone?: string;
    websiteUrl?: string;
    institutionCode?: string;
    directionsUrl?: string;
    consentFormUrl?: string;
    privacyPolicyUrl?: string;
    googleReviewUrl?: string;
    allowsOnlineInitialAppointments?: boolean;
}
export const PatchedPracticeUpdate_name_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const PatchedPracticeUpdate_organizations_Validators: ValidatorFn[] =
    [ ];

export const PatchedPracticeUpdate_street_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedPracticeUpdate_houseNumber_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const PatchedPracticeUpdate_postalCode_Validators: ValidatorFn[] =
    [  Validators.maxLength(10),];

export const PatchedPracticeUpdate_city_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedPracticeUpdate_owner_Validators: ValidatorFn[] =
    [ ];

export const PatchedPracticeUpdate_email_Validators: ValidatorFn[] =
    [  Validators.maxLength(254),];

export const PatchedPracticeUpdate_phone_Validators: ValidatorFn[] =
    [  Validators.maxLength(63),];

export const PatchedPracticeUpdate_websiteUrl_Validators: ValidatorFn[] =
    [  Validators.maxLength(200),];

export const PatchedPracticeUpdate_institutionCode_Validators: ValidatorFn[] =
    [  Validators.maxLength(9),];

export const PatchedPracticeUpdate_directionsUrl_Validators: ValidatorFn[] =
    [  Validators.maxLength(200),];

export const PatchedPracticeUpdate_consentFormUrl_Validators: ValidatorFn[] =
    [  Validators.maxLength(200),];

export const PatchedPracticeUpdate_privacyPolicyUrl_Validators: ValidatorFn[] =
    [  Validators.maxLength(200),];

export const PatchedPracticeUpdate_googleReviewUrl_Validators: ValidatorFn[] =
    [  Validators.maxLength(200),];

export const PatchedPracticeUpdate_allowsOnlineInitialAppointments_Validators: ValidatorFn[] =
    [ ];


